import { ApolloClient, NormalizedCacheObject } from '@apollo/client'
import { TokenQuery, TokenData } from '../queries/token'

export const fetchTokenPrice = async (
  client: ApolloClient<NormalizedCacheObject>,
  currentEthPrice = 0,
  tokenAddress: string,
): Promise<number> => {
  const {
    data: {
      token,
    },
  } = await client.query<{ token: TokenData }>({
    query: TokenQuery,
    variables: { address: tokenAddress.toLowerCase() },
  })
  if (!token) {
    return 0
  }

  const { derivedETH } = token;
  return parseFloat(derivedETH) * currentEthPrice
}
